import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

const SERVICES_COL_1 = [
  { label: "Diagnostyka Zdrowia", href: "/#zdrowie" },
  { label: "Secure Match", href: "/#match" },
  { label: "Secure Natal", href: "/#natal" },
  { label: "Genetyka Reprodukcyjna", href: "/#ivf" },
  { label: "Kontakt", href: "/#kontakt" },
];

const SERVICES_COL_2 = [
  { label: "Jak to działa", href: "/#proces" },
  { label: "Dlaczego Hiszpania", href: "/#why-spain-section" },
  { label: "O Nuuma", href: "/#top" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-white mt-[11rem] pt-8">
      <div className="nuuma-container">
        <div className="bg-nuuma-primary rounded-t-[40px] text-white px-8 sm:px-12 lg:px-16 pt-16 lg:pt-20 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10">
            {/* Col 1 — Full wordmark */}
            <div className="lg:col-span-1">
              <img
                src="/assets/nuuma-logo.svg"
                alt="Nuuma Genetics"
                className="h-10 lg:h-12 w-auto brightness-0 invert"
              />
            </div>

            {/* Col 2 — Contact */}
            <div
              data-testid="footer-contact-col"
              className="space-y-6 text-[0.92rem] text-white/90 leading-relaxed"
            >
              <div className="flex gap-3">
                <MapPin className="h-5 w-5 shrink-0 text-white mt-0.5" strokeWidth={1.5} />
                <div>
                  Centrum medyczne V76
                  <br />
                  Avda. de Dénia, 76 · 03016 · Alicante · Hiszpania
                </div>
              </div>

              <a
                href="tel:+48221004239"
                className="flex items-center gap-3 hover:text-nuuma-accent1 transition-colors"
              >
                <Phone className="h-5 w-5 shrink-0" strokeWidth={1.5} />
                <span>+48 22 100 42 39</span>
              </a>

              <a
                href="https://wa.me/48221004239"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-nuuma-accent1 transition-colors"
              >
                <MessageCircle className="h-5 w-5 shrink-0" strokeWidth={1.5} />
                <span>+48 22 100 42 39</span>
              </a>

              <a
                href="mailto:info@nuumagenetics.pl"
                className="flex items-center gap-3 hover:text-nuuma-accent1 transition-colors"
              >
                <Mail className="h-5 w-5 shrink-0" strokeWidth={1.5} />
                <span>info@nuumagenetics.pl</span>
              </a>
            </div>

            {/* Col 3 — Services */}
            <nav
              data-testid="footer-services-col-1"
              aria-label="Usługi"
              className="space-y-5 text-[0.92rem]"
            >
              {SERVICES_COL_1.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="block text-white/90 hover:text-nuuma-accent1 transition-colors"
                >
                  {s.label}
                </a>
              ))}
            </nav>

            {/* Col 4 — Secondary links */}
            <nav
              data-testid="footer-services-col-2"
              aria-label="Więcej"
              className="space-y-5 text-[0.92rem]"
            >
              {SERVICES_COL_2.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="block text-white/90 hover:text-nuuma-accent1 transition-colors"
                >
                  {s.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Bottom bar */}
          <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-white/70">
              © 2026 · nuuma genetics · Wszelkie prawa zastrzeżone
            </p>
            <ul className="flex flex-wrap items-center gap-x-2 gap-y-2 text-xs text-white/70">
              <li>
                <Link
                  to="/informacje-prawne"
                  className="hover:text-white transition-colors"
                >
                  Informacje prawne
                </Link>
              </li>
              <li className="text-white/30">·</li>
              <li>
                <Link
                  to="/polityka-prywatnosci"
                  className="hover:text-white transition-colors"
                >
                  Polityka prywatności
                </Link>
              </li>
              <li className="text-white/30">·</li>
              <li>
                <Link
                  to="/polityka-cookies"
                  className="hover:text-white transition-colors"
                >
                  Polityka plików cookie
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
